import { render, staticRenderFns } from "./BraintreePublicKey.vue?vue&type=template&id=2478d8bc&"
import script from "./BraintreePublicKey.vue?vue&type=script&lang=ts&"
export * from "./BraintreePublicKey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports